<!-- Wrapper -->
<app-header></app-header>
<router-outlet (activate)="onActivate($event)" ></router-outlet>
<!--<router-outlet></router-outlet>-->
<app-footer></app-footer>
